<template>
  <div v-if="$root.globalData" class="box">
    <div class="main__category__text">
      <h4 class="blogdesc__title">
        {{ $root.globalData.keys.unit_industry_category }} :
      </h4>
      <span> {{ getCategories(unit.categories) }} </span>
    </div>
    <div class="main__category__text">
      <h4 class="blogdesc__title">
        {{ $root.globalData.keys.unit_industry_town }} :
      </h4>
      <span> {{ unit.town.title }} </span>
    </div>
    <div class="main__category__text">
      <h4 class="blogdesc__title">
        {{ $root.globalData.keys.unit_location }} :
      </h4>
      <span> {{ unit.town.city.province.name }} </span>
    </div>
    <div class="main__category__text">
      <h4 class="blogdesc__title">{{ $root.globalData.keys.unit_year }} :</h4>
      <span> {{ unit.established_year }} </span>
    </div>
    <div class="main__category__text">
      <h4 class="blogdesc__title">{{ $root.globalData.keys.ceoTitle }} :</h4>
      <span> {{ unit.CEO }} </span>
    </div>

    <div class="addressBox">
      <div class="address" v-if="unit.website">
        <h4 class="blogdesc__title">{{ $root.globalData.keys.website_text }} :</h4>
        <a :href="unit.website" target="_blank"> {{ unit.website }} </a>
      </div>
    </div>
    <table id="addressesTable">
      <thead>
        <tr>
          <th>{{ $root.globalData.keys.unit_address }}</th>
          <th>{{ $root.globalData.keys.mobile_text }}</th>
          <th>{{ $root.globalData.keys.static_number_text }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in unit.addresses" :key="index">
          <td>
            {{ item.title }}
          </td>
          <td class="mobiles">
            <a
            v-for="mobile in item.mobile.split(',')"
            :key="mobile"
            style="color:white;"
                :href="`tel://${mobile}`"
              >
                {{mobile }}
              </a>
          </td>
          <td>
            {{ item.phones }}
          </td>
        </tr>
      </tbody>
    </table>
   
  </div>
</template>

<script>
export default {
  methods: {
    
    getCategories(categories) {
      if (categories == null || categories.length == 0) {
        return "";
      } else {
        let res = [];
        categories.forEach((cate) => {
          res.push(cate.title);
        });
        return res.join("-");
      }
    },
  },
  data() {
    return {
      blogcategorydesc: [
        { title: "دسته بندی صنایع", text: "صنعن وآهن و فولاد" },
        { title: "منطقه صنعتی", text: "شهرک صنعتی فولادشهر" },
        { title: "محل استقرار", text: "استان اصفهان" },
        { title: "سال تاسیس", text: "۱۳۲۰ هجری شمسی" },
      ],
      address: [
        {
          address: " آدرس",
          addressText:
            "اصفهان - اتوبان ذوب آهن - شهرک صنعتی اشترجان - خیابان ششم - پلاک 57",
        },
      ],
      blogcategorycount: 4,
    };
  },
  props: {
    unit: Object,
  },
};
</script>

<style scoped>
table#addressesTable tbody tr td {
    color: white;
    text-align: center;
    padding: 5px;
}
table#addressesTable {
  margin: 20px 0;
}
table#addressesTable tbody tr {
    background: #4c4c4c;
}
table#addressesTable thead tr th {
    padding: 5px;
    color: #3d8bfd;
    text-align: center;
}
table#addressesTable {
    width: 100%;
}
table#addressesTable thead {
    width: 100%;
    background: #80808042;
}
.box {
  display: flex;
  flex-wrap: wrap;
}
.main__category__text {
  display: flex;
  width: 50%;
}
.blogdesc__title a {
  color: black;
  cursor: pointer;
}
.blogdesc__title {
  min-width: max-content;
  color: #3d8bfd;
  margin-bottom: 10px;
  margin-left: 10px;
}
.main__category__text span {
  font-size: 14px;
}
.address {
  margin: 10px 0;
  display: flex;
}

.address span {
  font-size: 14px;
}

@media only screen and (max-width: 1000px) {
  .main__category__text {
    flex-wrap: wrap;
    width: 100%;
  }
}

@media only screen and (max-width: 768px) {
}
td.mobiles {
    display: flex;
    flex-direction: column;
}
</style>
